module.exports = __webpack_public_path__ + "static/img/telescope.2102a162.svg";